import RootyImg from '../assets/tree/rooty.svg';
import DomaImg from '../assets/tree/doma.svg';
import LetsGoImg from '../assets/tree/letsgo.svg';
import CodyImg from '../assets/tree/cody.svg';
import RushmoreImg from '../assets/tree/rushmore.svg';
import UniImg from '../assets/tree/uni.svg';
import GuestUniImg from '../assets/tree/uni-with-heart.svg';

export const getKidsCompanionImg = (friend) => {
  let image;
  switch (friend) {
    case 'letsgo':
      image = LetsGoImg;
      break;
    case 'cody':
      image = CodyImg;
      break;
    case 'rushmore':
      image = RushmoreImg;
      break;
    case 'doma':
      image = DomaImg;
      break;
    case 'rooty':
      image = RootyImg;
      break;
    case 'uni':
      image = UniImg;
      break;
    case 'guest':
      image = GuestUniImg;
      break;
    default:
      image = UniImg;
  }
  return image;
};
